/*
 * ct-gift-ladder.js
 *
 * Cadeauladder in de cart drawer: één rij kaarten (gratis verzending en de
 * gratis gifts, oplopend op drempel) met per kaart: icoon of productfoto,
 * een kort label ("Gratis gift") en het drempelbedrag. Behaald = gouden
 * rand met vinkje. Achter de kaarten loopt een gouden voortgangslijn: tot
 * het midden van de laatst behaalde kaart, plus het stuk naar de volgende
 * kaart naar rato van wat er al richting die drempel in de mand zit. Die
 * volgende kaart krijgt daarnaast een gouden rand die vanaf de linkerzijde
 * (waar de lijn binnenkomt) boven- en onderlangs naar rechts groeit
 * (David, 27-9). Passen de kaarten niet, dan scrolt de rij tot de rand van
 * de drawer (ct-drag-row, handler in cart-form.js).
 *
 * COMPACTE STAND (David, 27-9): zit er niets in de mand waar een giftregel
 * bij hoort, dan is er alleen gratis verzending en rendert de ladder één
 * regel: voortgangsring + "Nog €25 tot gratis verzending". Geen kaarten.
 *
 * MERKTABS (David, 29-9): bij meer dan één merk met gifts in de mand staan
 * er tabs als segmented control, elk met een mini-voortgangsring naar de
 * volgende gift van dat merk. De ladder SCHAKELT AUTOMATISCH mee: zodra er
 * een product bij komt (samenstelling verandert), springt de tab naar het
 * merk van het laatst toegevoegde betaalde product. Een aantalwijziging
 * schakelt niet, zodat een tab die de klant zelf koos niet wegspringt
 * terwijl hij ernaar kijkt. Zie switchTabForNewLines().
 *
 * UITVERKOCHTE GIFTS (David, 13-10): een trede waarvan geen enkele gift
 * meer leverbaar is, verdwijnt uit de ladder. De app voegt zo'n gift niet
 * toe (variant niet beschikbaar), dus een kaart ervoor is een loze
 * belofte. De voorraad komt NIET uit de app-JSON (daar staat hij niet in)
 * maar uit /products/<handle>.js via ctEasyGift.giftInfo(): `available`
 * van de variant, realtime van Shopify zelf. Zie tierAvailable(). Bij een
 * keuzetrede vallen alleen de uitverkochte producten weg; de trede blijft
 * zolang er één te kiezen is. Tot de productdata binnen is, telt een gift
 * als leverbaar (geen flits), daarna rendert de ladder opnieuw. Bij elke
 * OPENING van de drawer (CartDrawer:open) wordt de voorraad van de gifts
 * in de ladder hergecheckt via ctEasyGift.refresh() (throttle 60 s per
 * gift), zodat een gift die tijdens de sessie uitverkoopt niet tot het
 * sluiten van het tabblad blijft staan; alleen bij een wijziging volgt
 * een nieuwe render. Een
 * behaalde trede met uitverkochte gift verdwijnt ook; dat is bewust
 * (vinkje tonen voor iets wat niet komt is erger). De actievoorwaarden-
 * pagina (ct-gift-terms.js) volgt sinds 13-10 dezelfde regel: een trede
 * zonder leverbare gift verdwijnt ook daar. Alleen een los uitverkocht
 * cadeau binnen een trede die nog wél leverbaar is, krijgt daar het label
 * "tijdelijk uitverkocht".
 *
 * Klik op een gift-kaart opent een kleine popup BÍNNEN de drawer met foto,
 * naam en waarde van de gift (David, 25-9: kaarten kort houden, details op
 * aanvraag). De popup hangt aan #HeaderCart; omdat dat paneel een transform
 * heeft is position: fixed daarbinnen relatief aan het paneel.
 *
 * BRON VAN WAARHEID = EasyGift. De ladder stelt zelf niets in en rekent geen
 * korting uit. Hij leest de actieve regels van de app (via ct-eg-rules.js) en
 * de cart-markup van het theme, en toont waar de klant staat. De app voegt
 * de gifts toe en bepaalt de prijs. Loopt deze laag vast, dan mist de klant
 * hooguit een rijtje kaarten; het kost nooit geld.
 *
 * Rekenregels (afgestemd op de app-instellingen van 24-9-2026):
 * - Merkgroep = de set collecties van een regel. Regels met dezelfde set
 *   vormen één ladder. De merknaam komt uit de vendor van de cartregels die
 *   erin vallen, dus er hoeft niets per merk ingesteld te worden.
 * - Alleen treden met een BEDRAGdrempel (thresholdType 'value'). Een
 *   aantal-drempel (3 stuks) kan de ladder niet tekenen; die staat wel op
 *   de actievoorwaarden-pagina (ct-gift-terms.js).
 * - Drempelbedrag per groep = som van original_line_price (bruto, vóór
 *   korting; useFinalPrice staat uit in de app) van de regels die in een
 *   collectie van de groep zitten, zonder de gifts zelf (_Gifted).
 *   HYPOTHESE tot de QA-test: of de app een gift die toevallig in een
 *   triggercollectie zit zelf meetelt, is niet vastgesteld.
 * - Gratis verzending rekent op cart.total_price (na korting), want dat is
 *   waar Shopify de verzendkosten op bepaalt. Drempel uit de theme setting
 *   ct_free_shipping_threshold (via het snippet).
 * - Meerdere merken in de mand: merktabs; bij de eerste render het merk dat
 *   het dichtst bij zijn volgende gift zit, daarna het laatst toegevoegde.
 *   De verzendkaart staat in elke merkladder.
 *
 * Cart-data komt uit de markup: data-ct-line, data-vendor, data-collections
 * en data-variant-id op .cart__item (snippets/cart-item.liquid). cart-form.js
 * vuurt 'cart:markup' na elke verse markup, met het VERSE .cart__items-element
 * (dat hoeft niet in de DOM te hangen: bij een aantalwijziging laat
 * cart-form.js de bestaande regels staan). Geen eigen fetch naar /cart.js.
 *
 * Productgegevens (naam, foto, waarde, voorraad): ctEasyGift.giftInfo() in
 * ct-eg-rules.js (verhuisd op 5-10, gedeeld met de actievoorwaarden-
 * pagina; één fetch en één sessionStorage-cache). Tot de gegevens binnen
 * zijn staat er een gift-icoon; daarna rendert de ladder opnieuw.
 *
 * Toegankelijkheid: gift-kaarten zijn gewone <button>s (geen list/listitem-
 * rollen: die zouden de knoprol overschrijven); de verzendkaart is een div.
 *
 * Teksten komen als data-attributen mee uit snippets/ct-cart-gift-ladder.liquid.
 * Styling: assets/ct-cart-modules.css, sectie 14 en 15.
 *
 * ICON.gift (David, 28-9): cadeaudoos met strik, hetzelfde icoon als op de
 * regel-badge (snippets/cart-item.liquid) en in de EasyGift-keuzesheet
 * (ct-gift-picker.css). Wijzig je het hier, wijzig het daar.
 *
 * Bewust geen ES module (zie ct-gift-picker.js): <script defer> uit
 * snippets/preload-js.liquid, na ct-eg-rules.js.
 */
(function () {
  'use strict';

  var ROOT_SEL = '[data-ct-ladder]';
  var DRAWER_ID = 'HeaderCart';
  var ITEMS_SEL = '#HeaderCart .cart__items';
  var LINE_SEL = '.cart__item';
  var RING_R = 9;       /* straal van de voortgangsring (viewBox 24) */
  var OUTLINE_R = 9;    /* hoekstraal van de kaartrand (kaart 10px, 1px naar binnen) */
  var OUTLINE_INSET = 1;
  var RESIZE_DEBOUNCE = 150;
  var SVG_NS = 'http://www.w3.org/2000/svg';

  var ICON = {
    gift: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><rect x="3" y="8" width="18" height="4" rx="1"></rect><path d="M12 8v13"></path><path d="M19 12v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-7"></path><path d="M7.5 8a2.5 2.5 0 0 1 0-5A4.8 8 0 0 1 12 8a4.8 8 0 0 1 4.5-5 2.5 2.5 0 0 1 0 5"></path></svg>',
    parcel: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M12 2.8l8 4.2v10l-8 4.2-8-4.2V7z"></path><path d="M4 7l8 4.2L20 7"></path><path d="M12 11.2v10"></path><path d="M8 4.9l8 4.2"></path></svg>',
    check: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M5 12.5l4.5 4.5L19 7.5"></path></svg>',
    close: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6L6 18"></path></svg>'
  };

  var root = null;
  var els = {};
  var pop = {};
  var t = {};
  var state = { tab: null, lastItems: null, cards: [], popIndex: -1, lineSig: null };
  var shipThreshold = 0;
  var resizeTimer = null;

  /* ------------------------------------------------------------------ */
  /* Hulpfuncties                                                        */
  /* ------------------------------------------------------------------ */

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* Hele euro's zonder ",00"; centen alleen als ze er zijn. */
  function money(cents) {
    var v = Math.max(0, Math.round(cents)) / 100;
    var s = v.toFixed(2).replace('.', ',');
    if (s.slice(-3) === ',00') s = s.slice(0, -3);
    return '\u20ac' + s;
  }

  function tpl(key, vars) {
    var s = t[key] || '';
    Object.keys(vars || {}).forEach(function (k) {
      s = s.replace(new RegExp('{{\\s*' + k + '\\s*}}', 'g'), vars[k]);
    });
    return s;
  }

  function clamp01(v) {
    return Math.max(0, Math.min(1, v));
  }

  /* Voortgangsring (0..1) als inline SVG; bij 1 een vinkje. */
  function ringHtml(progress) {
    var c = 2 * Math.PI * RING_R;
    var p = clamp01(progress);
    if (p >= 1) {
      return '<span class="ct-ladder__ring is-done" aria-hidden="true">' + ICON.check + '</span>';
    }
    return '<span class="ct-ladder__ring" aria-hidden="true"><svg viewBox="0 0 24 24" focusable="false">' +
      '<circle class="ct-ladder__ring-track" cx="12" cy="12" r="' + RING_R + '"></circle>' +
      '<circle class="ct-ladder__ring-fill" cx="12" cy="12" r="' + RING_R + '" stroke-dasharray="' + c.toFixed(2) + '" stroke-dashoffset="' + (c * (1 - p)).toFixed(2) + '"></circle>' +
      '</svg></span>';
  }

  /* Deels gouden rand om een kaart. De paden worden pas in drawOutlines()
     getekend, als de kaartmaat bekend is; hier alleen de lege SVG met de
     voortgang als data-attribuut. */
  function outlineHtml(progress) {
    return '<svg class="ct-ladder__outline" data-ct-outline="' + clamp01(progress).toFixed(4) + '" aria-hidden="true" focusable="false"></svg>';
  }

  /* Twee halve paden vanaf het midden van de linkerzijde: één met de klok
     mee (bovenlangs), één tegen de klok in (onderlangs), beide eindigend in
     het midden van de rechterzijde. Met pathLength=100 op elk pad is de
     dasharray een percentage, onafhankelijk van de kaartmaat. */
  function drawOutlines() {
    els.tiers.querySelectorAll('.ct-ladder__outline').forEach(function (svg) {
      var card = svg.parentNode;
      var p = parseFloat(svg.getAttribute('data-ct-outline')) || 0;
      var w = card.offsetWidth;
      var h = card.offsetHeight;
      var i = OUTLINE_INSET;
      var r = OUTLINE_R;
      var L = i, R = w - i, T = i, B = h - i, M = h / 2;
      var top = 'M' + L + ',' + M +
        ' L' + L + ',' + (T + r) + ' A' + r + ',' + r + ' 0 0 1 ' + (L + r) + ',' + T +
        ' L' + (R - r) + ',' + T + ' A' + r + ',' + r + ' 0 0 1 ' + R + ',' + (T + r) +
        ' L' + R + ',' + M;
      var bottom = 'M' + L + ',' + M +
        ' L' + L + ',' + (B - r) + ' A' + r + ',' + r + ' 0 0 0 ' + (L + r) + ',' + B +
        ' L' + (R - r) + ',' + B + ' A' + r + ',' + r + ' 0 0 0 ' + R + ',' + (B - r) +
        ' L' + R + ',' + M;
      var dash = (p * 100).toFixed(2) + ' 100';

      svg.setAttribute('viewBox', '0 0 ' + w + ' ' + h);
      while (svg.firstChild) svg.removeChild(svg.firstChild);
      [top, bottom].forEach(function (d) {
        var path = document.createElementNS(SVG_NS, 'path');
        path.setAttribute('d', d);
        path.setAttribute('pathLength', '100');
        path.setAttribute('stroke-dasharray', dash);
        svg.appendChild(path);
      });
    });
  }

  function readLines(items) {
    var lines = [];
    items.querySelectorAll(LINE_SEL).forEach(function (el) {
      var d = el.dataset;
      if (!d.ctLine) return;
      var parts = d.ctLine.split(':');
      lines.push({
        original: parseInt(parts[0], 10) || 0,
        gifted: parts[1] === '1',
        vendor: d.vendor || '',
        collections: (d.collections || '').split(',').filter(Boolean),
        variantId: d.variantId || ''
      });
    });
    return lines;
  }

  /* ------------------------------------------------------------------ */
  /* Rekenen                                                             */
  /* ------------------------------------------------------------------ */

  function lineInGroup(line, g) {
    if (g.key === 'cart') return true;
    return line.collections.some(function (c) { return g.collections.indexOf(c) !== -1; });
  }

  function compute(lines, tiers) {
    var groups = {};
    tiers.forEach(function (tier) {
      var g = groups[tier.groupKey];
      if (!g) {
        g = groups[tier.groupKey] = { key: tier.groupKey, collections: tier.collections, tiers: [], subtotal: 0, label: '' };
      }
      g.tiers.push(tier);
    });

    Object.keys(groups).forEach(function (key) {
      var g = groups[key];
      var vendors = {};
      lines.forEach(function (line) {
        if (line.gifted) return;
        if (!lineInGroup(line, g)) return;
        g.subtotal += line.original;
        vendors[line.vendor] = (vendors[line.vendor] || 0) + 1;
      });
      var best = '';
      Object.keys(vendors).forEach(function (v) {
        if (v && (!best || vendors[v] > vendors[best])) best = v;
      });
      g.label = key === 'cart' ? (t.cartGroup || '') : best;

      var byThreshold = {};
      g.tiers.forEach(function (tier) {
        (byThreshold[tier.threshold] = byThreshold[tier.threshold] || []).push(tier);
      });
      g.steps = Object.keys(byThreshold).map(Number).sort(function (a, b) { return a - b; }).map(function (th) {
        return { threshold: th, tiers: byThreshold[th], reached: g.subtotal >= th, value: g.subtotal };
      });
      g.next = null;
      g.prevThreshold = 0;
      for (var i = 0; i < g.steps.length; i++) {
        if (!g.steps[i].reached) { g.next = g.steps[i]; break; }
        g.prevThreshold = g.steps[i].threshold;
      }
      g.remaining = g.next ? g.next.threshold - g.subtotal : 0;
      /* Voortgang naar de volgende gift van dit merk (0..1); alles gehaald = 1 */
      if (g.next) {
        var span = g.next.threshold - g.prevThreshold;
        g.progress = span > 0 ? clamp01((g.subtotal - g.prevThreshold) / span) : 0;
      } else {
        g.progress = g.steps.length ? 1 : 0;
      }
    });

    return groups;
  }

  /* Voortgang per kaart (0..1) voor de rij: behaald = 1; de eerstvolgende
     kaart na de laatst behaalde = de verhouding tussen die twee drempels
     (gemeten met de eigen waarde van die kaart); alles daarna = 0. Zonder
     behaalde kaart rekent de eerste kaart vanaf 0. */
  function progressPerCard(steps) {
    var out = [];
    var lastReached = -1;
    for (var i = 0; i < steps.length; i++) {
      out.push(steps[i].reached ? 1 : 0);
      if (steps[i].reached) lastReached = i;
    }
    var nextIdx = lastReached + 1;
    if (nextIdx < steps.length) {
      var prevTh = lastReached >= 0 ? steps[lastReached].threshold : 0;
      var next = steps[nextIdx];
      var span = next.threshold - prevTh;
      out[nextIdx] = span > 0 ? clamp01((next.value - prevTh) / span) : 0;
    }
    return out;
  }

  /*
    Automatisch meeschakelen (David, 29-9). De samenstelling = de set
    variant-id's van de betaalde regels (gifts uitgezonderd). Komt er een
    id bij dat er vorige keer niet was, dan springt de tab naar de groep
    van het bovenste betaalde item: Shopify zet het laatst toegevoegde item
    bovenaan, dus dat is wat de klant net deed. Alleen verwijderen of een
    aantalwijziging schakelt niet. Bij de eerste render (pageload) is er
    geen vorige samenstelling; dan geldt de 'dichtstbijzijnde gift'-regel
    in render().
  */
  function switchTabForNewLines(lines, active) {
    var paid = lines.filter(function (l) { return !l.gifted; });
    var ids = paid.map(function (l) { return l.variantId; }).filter(Boolean);
    var sig = ids.slice().sort().join('|');
    var prev = state.lineSig;
    state.lineSig = sig;
    if (prev === null || sig === prev) return;

    var prevIds = prev.split('|');
    var added = ids.some(function (id) { return prevIds.indexOf(id) === -1; });
    if (!added || !paid.length) return;

    var top = paid[0];
    for (var i = 0; i < active.length; i++) {
      if (lineInGroup(top, active[i])) {
        state.tab = active[i].key;
        return;
      }
    }
  }

  /* ------------------------------------------------------------------ */
  /* Giftgegevens via ctEasyGift.giftInfo (ct-eg-rules.js)              */
  /* ------------------------------------------------------------------ */

  /* Komt een gift binnen, dan opnieuw renderen: de kaart krijgt zijn foto,
     de popup naam en waarde, en een uitverkochte gift valt weg. */
  function onInfo() {
    render();
  }

  /* `available` is true zolang de productdata nog niet binnen is (geen
     flits: de kaart verdwijnt pas als Shopify zegt dat de variant niet
     leverbaar is). Een mislukte fetch levert in ct-eg-rules.js ook
     available: true op (onbekend is niet uitverkocht); alleen een 404
     geeft false. */
  function giftFor(key, fallbackTitle) {
    var info = window.ctEasyGift ? ctEasyGift.giftInfo(key, onInfo) : null;
    return {
      key: key,
      title: (info && info.title) || fallbackTitle || '',
      image: info ? info.image : '',
      price: info ? info.price : 0,
      available: info ? info.available === true : true
    };
  }

  /* Alle gifts van een regel, inclusief uitverkochte; onbekende gegevens
     worden op de achtergrond opgehaald. Een keuzeproduct zonder handle kan
     niet gecontroleerd worden en telt als leverbaar. */
  function tierGifts(tier) {
    var out = [];
    if (tier.choice) {
      tier.choice.products.forEach(function (p) {
        if (p.handle) {
          out.push(giftFor('h:' + p.handle, p.title));
        } else {
          out.push({ key: '', title: p.title || '', image: '', price: 0, available: true });
        }
      });
    } else {
      tier.gifts.forEach(function (vid) {
        out.push(giftFor('v:' + vid, ''));
      });
    }
    return out;
  }

  /* Een regel is leverbaar zolang minstens één van zijn gifts dat is. */
  function tierAvailable(tier) {
    return tierGifts(tier).some(function (g) { return g.available; });
  }

  /* Alle gift-keys van de bedrag-treden, voor de hercheck bij het openen.
     Bewust alle merken en niet alleen de zichtbare tab: de klant kan
     direct na het openen van tab wisselen. Hooguit een handvol keys. */
  function allGiftKeys() {
    var keys = [];
    (window.ctEasyGift ? ctEasyGift.tiers() : []).forEach(function (tier) {
      if (tier.thresholdType !== 'value') return;
      tierGifts(tier).forEach(function (g) {
        if (g.key && keys.indexOf(g.key) === -1) keys.push(g.key);
      });
    });
    return keys;
  }

  function refreshOnOpen() {
    if (!window.ctEasyGift || !ctEasyGift.refresh || !root || root.hidden) return;
    ctEasyGift.refresh(allGiftKeys(), function (changed) {
      if (changed) render();
    });
  }

  /* De LEVERBARE gifts van een trede als [{key, title, image, price}]. Bij
     een keuzetrede blijven zo alleen de producten over die de klant echt
     kan kiezen; bij een automatische regel is dit óf alles óf niets, en
     'niets' komt hier niet meer, want zo'n regel is al uit de treden
     gefilterd (zie render()). */
  function stepGifts(step) {
    var out = [];
    step.tiers.forEach(function (tier) {
      tierGifts(tier).forEach(function (g) {
        if (g.available) out.push(g);
      });
    });
    return out;
  }

  function stepIsChoice(step) {
    return !!(step.tiers[0] && step.tiers[0].choice);
  }

  /* Bij een keuzetrede nooit meer beloven dan er te kiezen valt: "Kies 2
     gifts" wordt "Kies je gift" als er na filtering één over is. */
  function stepLabel(step) {
    if (stepIsChoice(step)) {
      var n = Math.min(step.tiers[0].choice.count, stepGifts(step).length);
      return n > 1 ? tpl('giftChoice', { count: n }) : (t.giftChoiceOne || '');
    }
    return t.giftLabel || '';
  }

  function stepImage(step) {
    var gifts = stepGifts(step);
    for (var i = 0; i < gifts.length; i++) {
      if (gifts[i].image) return gifts[i].image;
    }
    return '';
  }

  /* ------------------------------------------------------------------ */
  /* Popup met details                                                   */
  /* ------------------------------------------------------------------ */

  function buildPop() {
    var drawer = document.getElementById(DRAWER_ID);
    if (!drawer) return;
    var el = document.createElement('div');
    el.className = 'ct-ladder-pop';
    el.hidden = true;
    el.innerHTML =
      '<div class="ct-ladder-pop__backdrop" data-ct-ladder-pop-close></div>' +
      '<div class="ct-ladder-pop__card" role="dialog" aria-modal="true" aria-label="' + esc(t.label) + '" tabindex="-1">' +
        '<button type="button" class="ct-ladder-pop__close" data-ct-ladder-pop-close aria-label="' + esc(t.close) + '">' + ICON.close + '</button>' +
        '<div class="ct-ladder-pop__body" data-ct-ladder-pop-body></div>' +
      '</div>';
    drawer.appendChild(el);
    pop.el = el;
    pop.card = el.querySelector('.ct-ladder-pop__card');
    pop.body = el.querySelector('[data-ct-ladder-pop-body]');

    el.addEventListener('click', function (evt) {
      if (evt.target.closest('[data-ct-ladder-pop-close]')) {
        evt.preventDefault();
        closePop();
      }
    });

    /* Escape sluit eerst de popup, niet de drawer (die luistert op keyup in
       de bubbelfase; capture is eerder aan de beurt). */
    window.addEventListener('keyup', function (evt) {
      if (evt.key !== 'Escape' && evt.keyCode !== 27) return;
      if (!pop.el || pop.el.hidden) return;
      evt.stopImmediatePropagation();
      closePop();
    }, true);
  }

  function renderPop() {
    if (!pop.el || state.popIndex < 0) return;
    var step = state.cards[state.popIndex];
    if (!step || step.ship) { closePop(); return; }

    var gifts = stepGifts(step);
    var head = step.threshold === 0 ? (t.anyPurchase || '') : tpl('from', { amount: money(step.threshold) });
    var html = '<p class="ct-ladder-pop__head">' +
      (step.reached ? '<span class="ct-ladder-pop__done">' + ICON.check + '</span>' : '') +
      esc(stepLabel(step)) + ' \u00b7 ' + esc(head) + '</p>';

    html += gifts.map(function (g) {
      var media = g.image ? '<img src="' + esc(g.image) + '" alt="" width="96" height="96">' : ICON.gift;
      return '<div class="ct-ladder-pop__item">' +
        '<span class="ct-ladder-pop__media">' + media + '</span>' +
        '<span class="ct-ladder-pop__text">' +
          '<span class="ct-ladder-pop__title">' + esc(g.title || t.giftLabel) + '</span>' +
          (g.price > 0 ? '<span class="ct-ladder-pop__worth">' + esc(tpl('worth', { amount: money(g.price) })) + '</span>' : '') +
        '</span>' +
      '</div>';
    }).join('');

    pop.body.innerHTML = html;
  }

  function openPop(index) {
    if (!pop.el) return;
    state.popIndex = index;
    renderPop();
    if (state.popIndex < 0) return;
    pop.returnFocus = document.activeElement;
    pop.el.hidden = false;
    requestAnimationFrame(function () { pop.el.classList.add('is-open'); });
    try { pop.card.focus({ preventScroll: true }); } catch (e) { pop.card.focus(); }
  }

  function closePop() {
    if (!pop.el || pop.el.hidden) return;
    state.popIndex = -1;
    pop.el.classList.remove('is-open');
    pop.el.hidden = true;
    if (pop.returnFocus && pop.returnFocus.isConnected) {
      try { pop.returnFocus.focus({ preventScroll: true }); } catch (e) { /* genegeerd */ }
    }
    pop.returnFocus = null;
  }

  /* ------------------------------------------------------------------ */
  /* Renderen                                                            */
  /* ------------------------------------------------------------------ */

  function build() {
    root.innerHTML =
      '<p class="ct-ladder__head" data-ct-ladder-head></p>' +
      '<div class="ct-ladder__tabs" data-ct-ladder-tabs role="group" aria-label="' + esc(t.tabs) + '"></div>' +
      '<div class="ct-ladder__tiers ct-drag-row" data-ct-ladder-tiers></div>';
    els.head = root.querySelector('[data-ct-ladder-head]');
    els.tabs = root.querySelector('[data-ct-ladder-tabs]');
    els.tiers = root.querySelector('[data-ct-ladder-tiers]');

    els.tabs.addEventListener('click', function (evt) {
      var btn = evt.target.closest('[data-ct-ladder-tab]');
      if (!btn) return;
      evt.preventDefault();
      state.tab = btn.getAttribute('data-ct-ladder-tab');
      render();
    });

    /* Klik op een gift-kaart: popup. De sleep-handler in cart-form.js
       onderdrukt de klik als er gesleept is, dus dit vuurt alleen bij een
       echte klik. */
    els.tiers.addEventListener('click', function (evt) {
      var card = evt.target.closest('[data-ct-ladder-card]');
      if (!card) return;
      evt.preventDefault();
      openPop(parseInt(card.getAttribute('data-ct-ladder-card'), 10));
    });

    buildPop();
  }

  function cardHtml(step, index, media, label, amount, progress) {
    var clickable = !step.ship;
    var tag = clickable ? 'button' : 'div';
    var partial = !step.reached && progress > 0;
    return '<' + tag + (clickable ? ' type="button" data-ct-ladder-card="' + index + '" title="' + esc(t.details) + '"' : '') +
      ' class="ct-ladder__tier' + (step.reached ? ' is-reached' : '') + '">' +
      (partial ? outlineHtml(progress) : '') +
      (step.reached ? '<span class="ct-ladder__done" aria-hidden="true">' + ICON.check + '</span>' : '') +
      '<span class="ct-ladder__media">' + media + '</span>' +
      '<span class="ct-ladder__name">' + esc(label) + '</span>' +
      '<span class="ct-ladder__amt">' + esc(amount) + '</span>' +
      (step.reached ? '<span class="visually-hidden">' + esc(t.unlocked) + '</span>' : '') +
    '</' + tag + '>';
  }

  /* Merktab: mini-ring (voortgang naar de volgende gift van dat merk),
     merknaam en het bedrag dat al meetelt. */
  function tabHtml(g, on) {
    return '<button type="button" class="ct-ladder__tab' + (on ? ' is-active' : '') + '" data-ct-ladder-tab="' + esc(g.key) + '" aria-pressed="' + (on ? 'true' : 'false') + '">' +
      ringHtml(g.progress) +
      '<span class="ct-ladder__tab-name">' + esc(g.label) + '</span>' +
      '<span class="ct-ladder__tab-amt">' + money(g.subtotal) + '</span>' +
    '</button>';
  }

  /* Voortgangslijn achter de kaarten: grijze lijn van het midden van de
     eerste tot het midden van de laatste kaart. Gouden vulling tot het
     midden van de laatst behaalde kaart, plus het stuk richting de
     eerstvolgende kaart naar rato (progressPerCard). Wordt na het renderen
     gemeten, want de breedtes hangen van de kaarten af. */
  function drawLine(steps, progress) {
    var cards = els.tiers.querySelectorAll('.ct-ladder__tier');
    if (!cards.length) return;

    function center(el) { return el.offsetLeft + el.offsetWidth / 2; }

    var start = center(cards[0]);
    var end = center(cards[cards.length - 1]);

    var lastReached = -1;
    for (var i = 0; i < steps.length; i++) {
      if (steps[i].reached) lastReached = i;
    }

    var fillTo = start;
    if (lastReached >= 0) {
      fillTo = center(cards[lastReached]);
      var nextIdx = lastReached + 1;
      if (nextIdx < steps.length) {
        fillTo += (center(cards[nextIdx]) - fillTo) * progress[nextIdx];
      }
    }

    var line = document.createElement('span');
    line.className = 'ct-ladder__line';
    line.setAttribute('aria-hidden', 'true');
    var fill = document.createElement('span');
    fill.className = 'ct-ladder__line-fill';
    line.appendChild(fill);
    els.tiers.insertBefore(line, els.tiers.firstChild);
    line.style.left = start + 'px';
    line.style.width = Math.max(0, end - start) + 'px';
    fill.style.width = Math.max(0, fillTo - start) + 'px';
  }

  /* Compacte stand: alleen verzending. Eén regel met ring en tekst. */
  function renderCompact(total, shipDone) {
    root.classList.add('ct-ladder--compact');
    var text = shipDone ? esc(t.shipDone) : tpl('shipTo', { amount: '<strong>' + money(shipThreshold - total) + '</strong>' });
    els.head.innerHTML = ringHtml(shipDone ? 1 : total / shipThreshold) + '<span class="ct-ladder__compact-text">' + text + '</span>';
    els.tabs.innerHTML = '';
    els.tabs.hidden = true;
    els.tiers.innerHTML = '';
    els.tiers.hidden = true;
    state.cards = [];
    closePop();
    root.hidden = false;
  }

  function render(items) {
    if (!root) return;
    if (items) state.lastItems = items;
    var el = state.lastItems || document.querySelector(ITEMS_SEL);
    if (!el) { root.hidden = true; closePop(); state.lineSig = null; return; }

    var lines = readLines(el);
    if (!lines.length) { root.hidden = true; closePop(); state.lineSig = null; return; }

    var total = parseInt(el.dataset.cartSubtotal, 10) || 0;
    /* Alleen bedrag-treden: een aantal-drempel kan de ladder niet tekenen.
       En alleen regels met minstens één leverbare gift (13-10): een
       uitverkochte gift voegt de app niet toe, dus die trede bestaat voor
       de klant niet. Valt zo de laatste trede van een merk weg, dan valt
       de groep weg en toont de ladder de compacte stand of een ander merk. */
    var tiers = (window.ctEasyGift ? ctEasyGift.tiers() : []).filter(function (tier) {
      return tier.thresholdType === 'value' && tierAvailable(tier);
    });
    var groups = compute(lines, tiers);

    /* Actieve groepen: er zit iets van in de mand. */
    var active = Object.keys(groups).map(function (k) { return groups[k]; }).filter(function (g) { return g.subtotal > 0; });

    /* Product erbij? Dan naar het merk van dat product (David, 29-9). */
    switchTabForNewLines(lines, active);

    var current = null;
    active.forEach(function (g) { if (g.key === state.tab) current = g; });
    if (!current && active.length) {
      active.forEach(function (g) {
        if (!current) { current = g; return; }
        var a = g.next ? g.remaining : Infinity;
        var b = current.next ? current.remaining : Infinity;
        if (a < b) current = g;
      });
      state.tab = current.key;
    }

    var shipOn = shipThreshold > 0;
    var shipDone = shipOn && total >= shipThreshold;

    if (!shipOn && !current) { root.hidden = true; closePop(); return; }

    if (!current) {
      renderCompact(total, shipDone);
      return;
    }
    root.classList.remove('ct-ladder--compact');

    /* Kopregel: dichtstbijzijnde beloning */
    var head = '';
    if (shipOn && !shipDone) {
      head = tpl('shipTo', { amount: '<strong>' + money(shipThreshold - total) + '</strong>' });
    } else if (current.next) {
      head = tpl('giftTo', { amount: '<strong>' + money(current.remaining) + '</strong>', brand: esc(current.label) });
    } else {
      head = tpl('allDone', { brand: esc(current.label) });
    }
    els.head.innerHTML = head;

    /* Merktabs: alleen bij meer dan één groep in de mand */
    if (active.length > 1) {
      els.tabs.innerHTML = active.map(function (g) {
        return tabHtml(g, g.key === current.key);
      }).join('');
      els.tabs.hidden = false;
    } else {
      els.tabs.innerHTML = '';
      els.tabs.hidden = true;
    }

    /* Kaarten: verzending en gifts samen, oplopend op drempel */
    var cards = [];
    if (shipOn) {
      cards.push({ ship: true, threshold: shipThreshold, reached: shipDone, value: total });
    }
    current.steps.forEach(function (s) { cards.push(s); });
    cards.sort(function (a, b) { return a.threshold - b.threshold; });
    state.cards = cards;
    var progress = progressPerCard(cards);

    els.tiers.innerHTML = cards.map(function (step, i) {
      var amount = step.threshold === 0 ? (t.anyPurchase || '') : money(step.threshold);
      if (step.ship) {
        return cardHtml(step, i, ICON.parcel, t.shipDone, amount, progress[i]);
      }
      var img = stepImage(step);
      var media = img ? '<img src="' + esc(img) + '" alt="" loading="lazy" width="80" height="80">' : ICON.gift;
      return cardHtml(step, i, media, stepLabel(step), amount, progress[i]);
    }).join('');
    els.tiers.hidden = false;

    root.hidden = false;
    drawLine(cards, progress);
    drawOutlines();
    if (state.popIndex >= 0) renderPop();
  }

  /* ------------------------------------------------------------------ */
  /* Start                                                               */
  /* ------------------------------------------------------------------ */

  function init() {
    root = document.querySelector(ROOT_SEL);
    if (!root) return;

    var d = root.dataset;
    shipThreshold = parseInt(d.shippingThreshold, 10) || 0;
    /* Locale-prefix voor de giftdata-fetches (routes.root_url uit Liquid). */
    if (window.ctEasyGift && d.root) ctEasyGift.setRoot(d.root);
    t = {
      shipTo: d.tShipTo, shipDone: d.tShipDone, giftTo: d.tGiftTo, giftLabel: d.tGiftLabel,
      giftChoice: d.tGiftChoice, giftChoiceOne: d.tGiftChoiceOne, allDone: d.tAllDone,
      anyPurchase: d.tAnyPurchase, unlocked: d.tUnlocked, cartGroup: d.tCartGroup, label: d.tLabel,
      worth: d.tWorth, from: d.tFrom, close: d.tClose, details: d.tDetails, tabs: d.tTabs
    };

    build();

    /* Verse markup uit cart-form.js (alle paden komen daar samen). */
    document.addEventListener('cart:markup', function (evt) {
      render(evt.detail && evt.detail.items);
    });

    /* Regels van de app komen pas na het laden binnen. */
    if (window.ctEasyGift) {
      ctEasyGift.ready(function () { render(); });
    }

    /* Verse voorraad bij elke opening van de drawer (cart-drawer.js). */
    document.addEventListener('CartDrawer:open', refreshOnOpen);

    /* Lijn en randen worden gemeten; bij resize opnieuw, met een korte
       debounce: mobiele browsers vuren resize bij elke adresbalk-beweging. */
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () { render(); }, RESIZE_DEBOUNCE);
    });

    render();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
